import { StyleSheet } from '@react-pdf/renderer';

export enum PdfCrossCheck {
    cross = 'cross',
    check = 'check',
}

export const styles = StyleSheet.create({
    page: {
        paddingHorizontal: 20,
        paddingTop: 20,
        paddingBottom: 50,
        fontSize: 10,
        fontFamily: 'Arial',
    },
    //Header-------------------------------------------------------------------------
    header: {
        fontSize: 16,
        textAlign: 'center',
        color: 'grey',
        width: '100%',
    },
    borderBottom: {
        borderBottom: '3px',
        borderColor: '#004652',
        marginBottom: 2,
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    rowSpaced: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    logo_title: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logoMacraDesign: {
        width: 150,
        height: 30,
        marginRight: 10,
    },
    ms10: { marginLeft: 10 },
    subtitle: {
        fontSize: 10,
    },
    leftLogo: {
        width: 200,
    },
    rightLogo: {
        width: 152,
        height: 29,
    },

    //Common-----------------------------------------------------------------------
    justifyContentAround: { justifyContent: 'space-around' },
    boldGreen: {
        fontWeight: 'ultrabold',
        color: '#004652',
    },
    rowCentered: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    gap3: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    //Body-------------------------------------------------------------------------
    body: {
        //backgroundColor: '#E4E4E4',
        width: '100%',
        padding: 10,
        textAlign: 'justify',
    },
    rowSpaceBetween: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    title: {
        fontSize: 14,
        borderBottom: 3,
        borderColor: '#004652',
        borderBottomStyle: 'dashed',
        paddingBottom: 5,
        paddingLeft: 10,
    },
    section35: {
        padding: 5,
        width: '35%',
    },
    section65: {
        padding: 5,
        width: '65%',
    },
    padding5: { padding: 5 },
    py10: { paddingVertical: 10 },
    py20: { paddingVertical: 20 },
    rowColor: { backgroundColor: '#DCE2E4' },
    projectSection: {
        padding: 5,
        flexGrow: 1,
        maxWidth: '50%',
    },
    sector: {
        width: '33%',
        textAlign: 'center',
        border: '1px solid #EEE',
    },
    note: { fontSize: 8 },
    disclaimerBox: {
        padding: 7,
        width: '80%',
        marginHorizontal: 'auto',
        marginTop: 10,
        border: '2px solid green',
    },
    disclaimerTitleBox: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 3,
    },
    greenRectangleDisclaimer: {
        height: '100%',
        width: 5,
        backgroundColor: 'green',
    },
    box: {
        border: '3px solid gray',
        padding: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    //Table material------------------------------------------------------------------------------------------ù
    headerTable: {
        backgroundColor: '#004652',
        color: '#fff',
    },
    borderRow: {
        border: '1px solid #EEE',
        paddingVertical: 3,
        textAlign: 'center',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    image: {
        width: '10px',
        height: '10px',
    },
    imgCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    //Footer------------------------------------------------------------------------------------------
    footer: { position: 'absolute', bottom: 20, left: 20, right: 20, borderTop: '3px', borderColor: '#004652', paddingTop: 10, fontSize: 8 },
});
